import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { OrderSubInfo } from 'src/app/interfaces/order-sub-info';
import { CheckoutService } from 'src/app/services/checkout.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Tabel } from 'src/app/interfaces/auth.interface';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {

  constructor(private checkout:CheckoutService, private router:Router, private aus: AuthService,private fs: AngularFirestore) { }

  linkRef: AngularFirestoreDocument<any>;

  link: Observable<any>;

  ordersub: OrderSubInfo[] = []

  confirmed:string = 'confirmed'

  methods = 'Cash Visa Mastercard'.split(' ');

  selectedmethod:string = ''

  Method: string = '';

  brunchMethods = 'البساتين العليا الياقوت'.split(' ');

  brunchSelectedMethod:string = ''

  brunchMethod: string = '';
  
  tabel: Tabel[] = [];

  payment:boolean = false

  brunch:boolean = false

  selected:string= "Please Select"
  
  ngOnInit(): void {

    this.linkRef = this.fs.collection('users').doc(`${this.aus.userId}`)
   
    this.link = this.linkRef.valueChanges();

    this.link.subscribe(data=> this.tabel = data)
  
  }


  onChange(newMethod) {
    this.payment = true
    this.selectedmethod = newMethod;
    this.Method = newMethod;
    console.log(this.Method)
  }

  brunchOnChange(newMethod) {
    this.brunch = true
    this.brunchSelectedMethod = newMethod;
    this.brunchMethod = newMethod;
    console.log(this.brunchMethod)
  }

  confirm(f:NgForm) {
      let status = (<OrderSubInfo>f.value).status,
          message = (<OrderSubInfo>f.value).message;
     this.checkout.confirmOrder(status,message,this.Method,this.brunchMethod)
     .then(()=>{ 
      this.router.navigate(['/'])
      document.getElementById('confirm-btn').style.display="none";
      document.getElementById('confirm-p').style.display="block";
      document.getElementById('done').style.display="block";
      setTimeout(()=>{
        document.getElementById('done').style.display="none";
      }, 5000);
     })

  }

}
